import React from 'react';
import EventTicker from './common/EventTicker';
import { Container, Row, Col } from 'react-bootstrap';
import { 
    ListChecks, 
    BarChart2, 
    PhoneCall, 
    Lightbulb, 
    Sparkles, 
    FileText, 
    ArrowRight 
} from 'lucide-react';

function DashboardPage({ onNavigateToApprovals, onNavigateToReports, onNavigateToEnquiryCall, onLogout, onSettings, pendingApprovalCount, userDisplayName }) {
    return (
        <div className="page-container">
            {/* Background blur effects */}
            <div className="bg-blur-indigo"></div>
            <div className="bg-blur-fuchsia"></div>
            
            {/* Header */}
            <header className="page-header">
                <div>
                    <h1 className="page-title">
                        HiveMind Network
                        <span className="header-badge">
                            Pro
                        </span>
                    </h1>
                    <p className="page-subtitle">
                        Your command center for growth and approvals.
                    </p>
                </div>
            </header>

            <Container fluid style={{ position: 'relative', zIndex: 10 }}>
                <Row className="g-4">
                    {/* Left Column - Action Cards */}
                    <Col lg={8}>
                        <Row className="g-4">
                            {/* Approvals Card */}
                            <Col md={6}>
                                <div 
                                    className="glass dashboard-card-glass"
                                    style={{
                                        padding: '1.5rem',
                                        borderRadius: '1.5rem',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        borderLeft: '4px solid #f97316',
                                        cursor: 'pointer'
                                    }}
                                    onClick={onNavigateToApprovals}
                                >
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        padding: '1rem',
                                        opacity: 0.5,
                                        transition: 'all 0.3s'
                                    }}>
                                        <ListChecks size={64} style={{ color: 'rgba(255, 255, 255, 0.05)' }} />
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '2rem'
                                    }}>
                                        <div style={{
                                            padding: '0.75rem',
                                            background: 'rgba(249, 115, 22, 0.2)',
                                            borderRadius: '0.75rem',
                                            color: '#fb923c'
                                        }}>
                                            <ListChecks size={24} />
                                        </div>
                                        {pendingApprovalCount > 0 && (
                                            <span style={{
                                                display: 'flex',
                                                height: '24px',
                                                width: '24px',
                                                position: 'relative'
                                            }}>
                                                <span style={{
                                                    position: 'absolute',
                                                    animation: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
                                                    height: '100%',
                                                    width: '100%',
                                                    borderRadius: '50%',
                                                    background: 'rgba(239, 68, 68, 0.75)'
                                                }}></span>
                                                <span style={{
                                                    position: 'relative',
                                                    borderRadius: '50%',
                                                    height: '24px',
                                                    width: '24px',
                                                    background: '#ef4444',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    color: 'white',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                className="theme-text">
                                                    {pendingApprovalCount}
                                                </span>
                                            </span>
                                        )}
                                    </div>
                                    <div>
                                        <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                            Approvals
                                        </h3>
                                        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginTop: '0.25rem', margin: 0 }}>
                                            {pendingApprovalCount > 0 ? `${pendingApprovalCount} items pending your review` : 'No pending approvals'}
                                        </p>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        gap: '0.25rem',
                                        marginTop: '1rem',
                                        height: '32px',
                                        opacity: 0.5,
                                        transition: 'opacity 0.3s'
                                    }}>
                                    </div>
                                </div>
                            </Col>
                            
                            {/* My Reports Card */}
                            <Col md={6}>
                                <div 
                                    className="glass dashboard-card-glass"
                                    style={{
                                        padding: '1.5rem',
                                        borderRadius: '1.5rem',
                                        cursor: 'pointer',
                                        borderLeft: '4px solid #60a5fa'
                                    }}
                                    onClick={onNavigateToReports}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '2rem'
                                    }}>
                                        <div style={{
                                            padding: '0.75rem',
                                            background: 'rgba(59, 130, 246, 0.2)',
                                            borderRadius: '0.75rem',
                                            color: '#60a5fa'
                                        }}>
                                            <BarChart2 size={24} />
                                        </div>
                                        <BarChart2 size={20} style={{ color: '#4b5563' }} />
                                    </div>
                                    <div>
                                        <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                            My Reports
                                        </h3>
                                        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginTop: '0.25rem', margin: 0 }}>
                                            View monthly performance
                                        </p>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        gap: '0.25rem',
                                        marginTop: '1rem',
                                        height: '32px',
                                        opacity: 0.5,
                                        transition: 'opacity 0.3s'
                                    }}>
                                        <div style={{ width: '8px', height: '16px', background: '#3b82f6', borderRadius: '2px' }}></div>
                                        <div style={{ width: '8px', height: '24px', background: '#60a5fa', borderRadius: '2px' }}></div>
                                        <div style={{ width: '8px', height: '12px', background: '#2563eb', borderRadius: '2px' }}></div>
                                        <div style={{ width: '8px', height: '32px', background: '#93c5fd', borderRadius: '2px' }}></div>
                                    </div>
                                </div>
                            </Col>
                            
                            {/* Enquiry Call Card */}
                            <Col md={6}>
                                <div 
                                    className="glass dashboard-card-glass"
                                    style={{
                                        padding: '1.5rem',
                                        borderRadius: '1.5rem',
                                        cursor: 'pointer',
                                        borderLeft: '4px solid #4ade80'
                                    }}
                                    onClick={onNavigateToEnquiryCall}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '2rem'
                                    }}>
                                        <div style={{
                                            padding: '0.75rem',
                                            background: 'rgba(34, 197, 94, 0.2)',
                                            borderRadius: '0.75rem',
                                            color: '#4ade80'
                                        }}>
                                            <PhoneCall size={24} />
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                            Enquiry Call
                                        </h3>
                                        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginTop: '0.25rem', margin: 0 }}>
                                            Expert insight on demand
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            
                            {/* Insights Card */}
                            <Col md={6}>
                                <div 
                                    className="glass dashboard-card-glass"
                                    style={{
                                        padding: '1.5rem',
                                        borderRadius: '1.5rem',
                                        cursor: 'pointer',
                                        borderLeft: '4px solid #a78bfa'
                                    }}
                                    onClick={() => alert('Coming Soon: Insights')}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '2rem'
                                    }}>
                                        <div style={{
                                            padding: '0.75rem',
                                            background: 'rgba(168, 85, 247, 0.2)',
                                            borderRadius: '0.75rem',
                                            color: '#a78bfa'
                                        }}>
                                            <Lightbulb size={24} />
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                            Insights
                                        </h3>
                                        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginTop: '0.25rem', margin: 0 }}>
                                            Discover new trends
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    
                    {/* Right Column - "Just for you" Card */}
                    <Col lg={4}>
                        <div 
                            className="ai-gradient"
                            style={{
                                height: '100%',
                                borderRadius: '1.5rem',
                                padding: '2rem',
                                position: 'relative',
                                overflow: 'hidden',
                                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div 
                                className="ai-card-blush"
                                style={{
                                    position: 'absolute',
                                    right: '-40px',
                                    top: '-40px',
                                    width: '160px',
                                    height: '160px',
                                    background: 'rgba(236, 72, 153, 0.3)',
                                    borderRadius: '50%',
                                    filter: 'blur(48px)'
                                }}
                            ></div>
                            
                            <div>
                                <div className="ai-card-badge">
                                    <Sparkles size={12} style={{ color: '#fde047' }} />
                                    AI Curated
                                </div>
                                <h2 className="ai-card-title">
                                    Just for you,<br />{userDisplayName || 'User'}.
                                </h2>
                                <p className="ai-card-description">
                                    Based on your interest in <span className="theme-text" style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationColor: '#ec4899' }}>Global Markets</span>, our AI thinks you might appreciate this new report on emerging tech sectors.
                                </p>
                                
                                <div className="ai-card-item">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                        <div className="ai-card-icon-bg">
                                            <FileText size={20} />
                                        </div>
                                        <div>
                                            <div className="theme-text" style={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
                                                Q4 Tech Innovations
                                            </div>
                                            <div className="ai-card-item-text">
                                                PDF • 5 min read
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button 
                                className="ai-card-button"
                                onClick={() => alert('Coming Soon: Just for you')}
                            >
                                Read Report <ArrowRight size={16} />
                            </button>
                        </div>
                    </Col>
                    
                    {/* Upcoming Events Section */}
                    <Col lg={12} style={{ marginTop: '1rem' }}>
                        <div 
                            className="glass"
                            style={{
                                borderRadius: '1.5rem',
                                padding: '1.5rem',
                                borderLeft: '4px solid #f59e0b'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1rem',
                                marginBottom: '1rem'
                            }}
                            className="flex-md-row justify-content-md-between align-items-md-center"
                            >
                                <div>
                                    <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', margin: 0 }}>
                                        Upcoming Events
                                    </h3>
                                    <p style={{ fontSize: '0.75rem', color: '#9ca3af', margin: 0 }}>
                                        Discover, connect, and grow through HiveMind's events.
                                    </p>
                                </div>
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <button style={{
                                        padding: '0.5rem',
                                        borderRadius: '0.5rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: 'none',
                                        color: 'white',
                                        cursor: 'pointer'
                                    }}>
                                        ←
                                    </button>
                                    <button style={{
                                        padding: '0.5rem',
                                        borderRadius: '0.5rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: 'none',
                                        color: 'white',
                                        cursor: 'pointer'
                                    }}>
                                        →
                                    </button>
                                </div>
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                gap: '1rem',
                                overflowX: 'auto',
                                paddingBottom: '0.5rem'
                            }}>
                                <EventTicker
                                    text={"Discover, connect, and grow through HiveMind's events, designed to inspire learning, collaboration, and professional success."}
                                    speedMs={30000}
                                    heightPx={48}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default DashboardPage;
